import * as React from "react";

// MUI
import {
	withStyles,
	WithStyles,
	createStyles,
	Theme,
} from "@material-ui/core/styles";
import { Grid, GridProps } from "@material-ui/core";

// NPM
import clsx from "clsx";
import { useSpring, animated } from "react-spring";

// Component
import CreditCardFront from "./CreditCardFront.Component";
import CreditCardBack from "./CreditCardBack.Component";
import CreditCardBackActionButtons from "./CreditCardBackActionButtons.Component";
import CreditCardFrontActionButtons from "./CreditCardFrontActionButtons.Component";

// Classes
import Utility from "../../domain/classes/Utility";

// Contexts
import { usePaymentManager } from "../../contexts/PaymentManager.Context";

export const styles = (theme: Theme) =>
	createStyles({
		root: {
			display: "block",
			position: "relative",
			perspective: 800,
		},
		card: {
			display: "block",

			position: "relative",
			height: theme.spacing(22),
			maxWidth: theme.spacing(38),
			margin: "auto",
			// transition: "transform 0.5s",
			transformStyle: "preserve-3d",
		},
		cardRoot: {
			position: "absolute",
			marginTop: 0,
			height: "100%",
			width: "100%",
			backfaceVisibility: "hidden",
			WebkitBackfaceVisibility: "hidden",
		},
		cardBack: {
			transform: "rotateY(180deg)",
		},
		cardFlip: {
			transform: "rotateY(180deg)",
		},
		cardFront: {},
		noDisplay: {
			display: "none",
		},
	});

export interface CreditCardProps extends GridProps {
	flippable?: boolean;
}

const AnimatedGrid = animated(Grid);

const CreditCard: React.FC<CreditCardProps & WithStyles<typeof styles>> = ({
	classes,
	className,
	flippable,
	...gridProps
}) => {
	const { cardFlipped } = usePaymentManager();

	const { y, ...rest } = useSpring({
		config: { tension: 180, friction: 18, mass: 4 },
		y: cardFlipped ? 180 : 0,
		from: { y: 0 },
	});

	return (
		<Grid
			container
			spacing={1}
			className={clsx(classes.root)}
			{...gridProps}
		>
			{flippable && (
				<AnimatedGrid
					item
					xs={12}
					className={clsx(classes.card)}
					style={{
						transform: y.interpolate((y) => `rotateY(${y}deg)`),
						...rest,
					}}
				>
					<CreditCardFront
						classes={{
							root: clsx(classes.cardRoot, classes.cardFront),
						}}
					/>
					<CreditCardBack
						classes={{
							root: clsx(classes.cardRoot, classes.cardBack),
						}}
					/>
				</AnimatedGrid>
			)}

			{cardFlipped ? (
				<React.Fragment>
					{!flippable && (
						<Grid item xs={12}>
							<CreditCardBack />
						</Grid>
					)}
					<CreditCardBackActionButtons />
				</React.Fragment>
			) : (
				<React.Fragment>
					{!flippable && (
						<Grid item xs={12}>
							<CreditCardFront />
						</Grid>
					)}
					<CreditCardFrontActionButtons />
				</React.Fragment>
			)}
		</Grid>
	);
};

export default withStyles(styles, {
	classNamePrefix: Utility.generateClassName("CreditCard"),
})(CreditCard);
